<template>
    <div class="top-wrap">
        <div class="top-wap-content">
            <div class="left">
                <ul>
                    <li class="location-area">
                        <span class="location">
                            <i></i>{{this.formatCity(defaultCity)}}
                        </span>
                        <div class="city-list">
                            <div class="city-tab">
                                <a v-for="(city, index) in cityShort" @click="changeCityShort(index)"
                                   :class="isSelected(index)">{{city}}</a>
                            </div>
                            <div class="city-short-list"  v-if="cityShortDefault.length > 0" v-show="defaultCityType == 'city_list'">
                                <dl v-for="item in cityShortDefault">
                                    <dt>{{item.firstStr}}</dt>
                                    <dd>
                                        <a v-for="obj in item.cities"
                                           @click="setDefaultCity(obj.areaId, obj.pinyin)">{{formatCity(obj.name)}}</a>
                                    </dd>
                                </dl>
                            </div>
                            <div v-else class="no-cities">
                                暂无城市列表
                            </div>
                        </div>
                    </li>
                    <li  v-if="!(userInfo && userInfo.realName)">
                        | &nbsp;&nbsp;欢迎来到万家！请<a :href="loginUrl" class="login">登录</a> |
                    </li>
                    <li v-if="!(userInfo && userInfo.realName)">
                        <a :href="registerUrl">注册</a>
                    </li>
                    <li v-if="userInfo && userInfo.realName">
                        | &nbsp;&nbsp;欢迎来到万家  <a :href="userCenter">{{userInfo.realName}}</a> | <a @click="logOut()">退出</a>
                    </li>
                </ul>
            </div>
            <div class="right">
                <ul>
                    <li>
                        <a :href="shoppingCart" class="shoppingCart"><i></i>购物车<b>{{$store.state.cartNum}}</b>件</a>
                        <span>|</span>
                    </li>
                    <li v-for="(item, index) in rightLink">
                        <a :href="item.url">{{item.title}}</a>
                        <span>|</span>
                    </li>
                    <li class="last-link">
                        <a target="_blank" :href="clinicRoot" class="clinic">
                            <b></b>
                            我是诊所
                            <i class="arr-down"></i>
                        </a>
                        <div class="myClinic">
                            <a target="_blank":href="myClinic" >
                                登录云诊所
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import url from '../../../config/url';
    import common from '../../../static/js/common'

    export default {
        data() {
            return {
                loginUrl: url.loginUrl,
                registerUrl: url.registerUrl,
                defaultSelectIndex: 0,
                defaultCityType: "city_list",
                userCenter: url.hyqtRoot,
                flag: true,
                cityShortDefault: [],
                cartNum: 0,
                cityShortA_F: [],
                cityShortG_J: [],
                cityShortK_Q: [],
                cityShortR_W: [],
                cityShortX_Z: [],
                cookieTime: 365,
                shoppingCart: url.cartRoot,
                clinicRoot: url.clinicRoot,
                myClinic: url.myClinic,
                cityShort: [
                    'ABCDEF',
                    'GHIJ',
                    'KLMNOPQ',
                    'RSTUVW',
                    'XYZ'
                ],
                rightLink: [
                    {
                        url: url.hyqtRoot,
                        title: "我的万家",
                    }, {
                        url: url.busRoot + "/open/activity",
                        title: "企业服务",
                    }, {
                        url: url.commonRoot + "/help",
                        title: "帮助中心",
                    }, {
                        url: url.commonRoot + "/appDownload",
                        title: "手机万家",
                    }
                ]

            }
        },
        created: function () {
            this.getLocationList();
            this.$store.dispatch("getCartNum");
            this.$store.dispatch("getUserInfo");
        },
        computed:{
            userInfo(){
                return this.$store.state.userInfo;
            },
            defaultCity(){
                return this.$store.state.defaultCity;
            }
        },
        mounted: function () {
            common.delCookie("areaId");
            common.delCookie("areaPinyin");
            common.setCookie("areaId", window.areaId, this.cookieTime);//默认上海
            common.setCookie("areaPinyin", window.areaPinyin, this.cookieTime);
        },
        methods: {
            logOut(){
                window.location.href = url.commonRoot + '/login/logout.do?targeturl='+encodeURI(url.casRoot+'/logout?service='+window.location.href);
            },
            //去除 "市"
            formatCity(city) {
                return city.replace("市", "");
            },
            // 设置默认城市
            setDefaultCity(areaId, pinyin) {
                var _this = this;
                var params = {
                    areaId: areaId,
                };
                axios.get(url.checkCitysiteAndGetCity, {
                    params: params
                }).
                then(function (response) {
                    var res = response.data.result;
                    if(parseInt(areaId) == parseInt(res.areaId)){
                        common.setCookie("areaId", areaId, _this.cookieTime);
                        common.setCookie("areaPinyin", pinyin, _this.cookieTime);
                        if(_this.$route.name == "Doctor"){
                            window.location = "/doctor";
                        }else if(_this.$route.name == "Clinic"){
                            window.location = "/clinic";
                        }else{
                            window.location = "/" + pinyin;
                        }

                    }else{
                        common.setCookie("areaId", res.areaId, _this.cookieTime);
                        common.setCookie("areaPinyin", res.pinyin, _this.cookieTime);
                        if(_this.$route.name == "Doctor"){
                            window.location = "/doctor";
                        }else if(_this.$route.name == "Clinic"){
                            window.location = "/clinic";
                        }else{
                            window.location = "/" + pinyin;
                        }
                    }
                }).catch(function () {
                    _this.$Message.error('数据获取失败,请稍后再试!');
                });
            },
            changeCityShort(index) {
                this.defaultSelectIndex = index;
                switch (index) {
                    case 0:
                        this.defaultCityType = "city_list";
                        this.cityShortDefault = this.cityShortA_F;
                        break;
                    case 1:
                        this.defaultCityType = "city_list";
                        this.cityShortDefault = this.cityShortG_J;
                        break;
                    case 2:
                        this.defaultCityType = "city_list";
                        this.cityShortDefault = this.cityShortK_Q;
                        break;
                    case 3:
                        this.defaultCityType = "city_list";
                        this.cityShortDefault = this.cityShortR_W;
                        break;
                    case 4:
                        this.defaultCityType = "city_list";
                        this.cityShortDefault = this.cityShortX_Z;
                        break;
                }
            },
            isSelected(index) {
                if (index == this.defaultSelectIndex) {
                    return "selected"
                }
            },
            getLocationList() {
                var _this = this;
                axios.get(url.getOpenCitySite)
                .then(function (response) {
                    var locationList = response.data.result;
                    if (locationList != null && locationList instanceof Array && locationList.length > 0) {
                        _this.locationList = locationList;
                        _this.locationList.forEach(function (item) {
                            item.cities.forEach(function (list) {
                                if(parseInt(list.areaId) == parseInt(window.areaId)){
                                    _this.$store.dispatch("getDefaultCity", list.name)
                                }
                            })
                            if(item.firstStr == "A" || item.firstStr == "B" ||
                                item.firstStr == "C" || item.firstStr == "D"
                                || item.firstStr == "F"){
                                _this.cityShortA_F.push(item);
                                _this.cityShortDefault =  _this.cityShortA_F;
                            }
                            if (item.firstStr == "G" || item.firstStr == "H" ||
                                item.firstStr == "I" || item.firstStr == "J") {
                                _this.cityShortG_J.push(item);
                            }
                            if (item.firstStr == "K" || item.firstStr == "L" || item.firstStr == "M"
                                || item.firstStr == "N"|| item.firstStr == "O" || item.firstStr == "P"
                                || item.firstStr == "Q") {
                                _this.cityShortK_Q.push(item);
                            }
                            if (item.firstStr == "R" || item.firstStr == "S" || item.firstStr == "T" ||
                                item.firstStr == "U" || item.firstStr == "V" || item.firstStr == "W") {
                                _this.cityShortR_W.push(item);
                            }
                            if (item.firstStr == "X" || item.firstStr == "Y" ||
                                item.firstStr == "Z") {
                                _this.cityShortX_Z.push(item);
                            }
                        })
                    }
                }).catch(function (error) {
                    _this.$Message.error('数据获取失败，请稍后再试!');
                });
            }
        }
    }
</script>
<style scoped lang="scss">
    @import "../../../static/scss/page/pageTopBar";
</style>


// WEBPACK FOOTER //
// src/components/Common/pageTopBar.vue